import { NotificationOption } from '@retail/suppliers/types';
import React from 'react';
import { Chip } from '@mui/material';
import { useSuppliersTFunction } from '@retail/suppliers/i18n';

interface Props {
  config: NotificationOption;
}

export const PriceChangeConfigChip: React.FC<Props> = ({ config }) => {
  const t = useSuppliersTFunction();
  switch (config) {
    case 'notify':
      return (
        <Chip
          size="small"
          label={t('suppliers.columns.priceChangeConfig.notify')}
          variant="outlined"
          color="success"
        />
      );
    case 'ignore':
    default:
      return (
        <Chip
          size="small"
          label={t('suppliers.columns.priceChangeConfig.ignore')}
          variant="outlined"
        />
      );
  }
};
